import type { FC } from 'react'
import { memo } from 'react'

import CommonButtons from './components/commonButtons'
import Toolbar from './components/toolbar'

import DetailsButton from '@app/pages/strategies/components/nodes/components/toolbar/components/detailsButton'
import type { DomainNode } from '@app/types'

interface Props {
  strategyId: string
  node: DomainNode
}

const SubmapToolbar: FC<Props> = ({ strategyId, node }) => {
  const { strategyId: currentStrategyId } = node
  const route = `/strategy/${currentStrategyId}/map/strategy/${node.data.id}`

  return (
    <Toolbar strategyId={strategyId}>
      <DetailsButton path={route} />
      <CommonButtons node={node} />
    </Toolbar>
  )
}

export default memo(SubmapToolbar)
